























































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { useAuthorizedSignerStore } from "@/employee/store/authorizedSigner";
import { AddAuthorizedSignerRequest, AuthorizedSigner, AuthorizedSignerStatus, FamilyMember, FamilyMemberRelationship, FamilyMemberStatus } from "@/shared/types";
import EditAuthorizedSigner from "@/employee/components/settings/EditAuthorizedSigner.vue";
import { useThemeStore } from "@/shared/store/theme";
import { useFamilyStore } from "@/employee/store/family";
import _ from "lodash";
import moment from "moment";

const emptyAuthorizedSigner: AuthorizedSigner = {
  id: 0,
  firstName: "",
  middleInitial: "",
  lastName: "",
  dateOfBirth: "",
  ssn: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
  phone: "",
  status: AuthorizedSignerStatus.Active,
  externalId: "",
  userFamilyMemberExternalId: ""
};
const defaultSelectedDependentId = 0;

const isNullEmptyOrUndefined = val => {
  return val === undefined || val === null || val === "";
};

@Component({
  components: {
    EditAuthorizedSigner
  }
})
export default class AddAuthorizedSigner extends Vue {
  themeStore = useThemeStore();
  authorizedSignerStore = useAuthorizedSignerStore();
  familyStore = useFamilyStore();
  editAuthorizedSignerParameters = {
    show: { value: false },
    authorizedSigner: { ...emptyAuthorizedSigner },
    onSave: this.onSaveAuthorizedSigner,
    toggleClose: this.closeEditAuthorizedSignerForm,
    isNew: true
  };
  orderDebitCard = false;
  selectedDependentId = defaultSelectedDependentId;
  editComponentKey = 0;
  authorizedDependentEligibilityCheckError = "";
  retainFormDataInMemory = false;
  showContinueWithIncompleteFormModal = false;

  showEditAuthorizedSignerForm () {
    this.authorizedDependentEligibilityCheckError = "";
    if (this.retainFormDataInMemory) {
      this.showContinueWithIncompleteFormModal = true;
    } else {
      this.startNewAuthorizedSignerForm();
    }
  }

  startNewAuthorizedSignerForm () {
    this.closePrefillConfirmationModal();
    this.retainFormDataInMemory = false;
    this.editAuthorizedSignerParameters.authorizedSigner = { ...emptyAuthorizedSigner };
    this.editAuthorizedSignerParameters.show.value = true;
    this.familyStore.initialize();
  }

  continueWithFormDataFromMemory () {
    this.closePrefillConfirmationModal();
    this.editAuthorizedSignerParameters.show.value = true;
  }

  closePrefillConfirmationModal () {
    this.showContinueWithIncompleteFormModal = false;
  }

  onSaveAuthorizedSigner () {
    const request: AddAuthorizedSignerRequest = {
      orderDebitCard: this.orderDebitCard,
      authorizedSigner: this.editAuthorizedSignerParameters.authorizedSigner
    };
    return this.authorizedSignerStore.addAuthorizedSigner(request)
      .then(() => {
        this.editAuthorizedSignerParameters.show.value = false;
        this.retainFormDataInMemory = false;
      })
      .catch(() => {/*noop*/ });
  }

  showAuthorizedDependentEligibilityCheckError (error: string, keep = false) {
    this.authorizedDependentEligibilityCheckError = error;
    this.retainFormDataInMemory = keep;
    if (this.hasEligibleDependents) {
      (this.$refs.dependentDropdown as any).focus();
    }
  }

  closeEditAuthorizedSignerForm () {
    this.editAuthorizedSignerParameters.show.value = false;
    this.selectedDependentId = defaultSelectedDependentId;
  }

  onDependentSelected (value) {
    this.authorizedDependentEligibilityCheckError = "";
    const dependent = this.eligibleDependents.find(d => d.id === value);
    if (!dependent || dependent === undefined) {
      return;
    }

    if (isNullEmptyOrUndefined(dependent.ssn)) {
      this.showAuthorizedDependentEligibilityCheckError(
        "Ssn is required for authorized signers. Please update this dependent's ssn before trying to authorize them"
        );
    }

    const keep = this.keepCurrentData(dependent);
    const authorizedSignerData = keep ? this.editAuthorizedSignerParameters.authorizedSigner : emptyAuthorizedSigner;
    this.updateAuthorizedSignerEditForm (authorizedSignerData, dependent);
    this.editComponentKey++;
  }

  onSsnChange () {
    this.validate();
  }

  validate () {
    this.authorizedDependentEligibilityCheckError = "";
    const retainFormData = true;
    const authorizedSignerSsn = this.editAuthorizedSignerParameters.authorizedSigner.ssn;
    if (!this.isDependentSelected && this.isExistingEligibleDependent(authorizedSignerSsn)) {
      this.showAuthorizedDependentEligibilityCheckError(
        "You are attempting to add an existing dependent as an Authorized user. Please select the dependent to Authorize.",
        retainFormData);
    }
    else if (!this.isDependentSelected && this.isExistingInactiveDependent(authorizedSignerSsn)) {
      this.showAuthorizedDependentEligibilityCheckError(
        "You are attempting to add an existing inactive dependent as an Authorized user. Please activate the dependent before trying to authorize them.",
        retainFormData);
    }
  }

  keepCurrentData (dependent) {
    return this.retainFormDataInMemory && this.editAuthorizedSignerParameters.authorizedSigner.ssn === dependent.ssn;
  }

  updateAuthorizedSignerEditForm (authorizedSigner: AuthorizedSigner, dependent: FamilyMember) {
    this.editAuthorizedSignerParameters.authorizedSigner = {
      ...authorizedSigner,
      firstName: dependent.firstName,
      middleInitial: dependent.middleInitial,
      lastName: dependent.lastName,
      dateOfBirth: dependent.dateOfBirth,
      ssn: dependent.ssn,
      userFamilyMemberExternalId: dependent.externalId
    };
  }

  clearDependentSelection () {
    this.editAuthorizedSignerParameters.authorizedSigner = _.cloneDeep({ ...emptyAuthorizedSigner });
    this.selectedDependentId = defaultSelectedDependentId;
    this.authorizedDependentEligibilityCheckError = "";
    this.editComponentKey++;
  }

  notAuthorizedYet (dependent: FamilyMember) {
    return !this.alreadyAuthorizedDependents ||
      this.alreadyAuthorizedDependents.length === 0 ||
      this.alreadyAuthorizedDependents.findIndex(id => id === dependent.externalId) < 0;
  }

  over18 (dependent: FamilyMember) {
    const dobMoment = moment(dependent.dateOfBirth);
    const now = moment();
    return now.diff(dobMoment, "years") >= 18;
  }

  isActiveDependent (dependent: FamilyMember) {
    return dependent.status === FamilyMemberStatus.Active;
  }

  isExistingEligibleDependent (authorizedSignerSsn: string) {
    if (isNullEmptyOrUndefined(authorizedSignerSsn)) {
      return false;
    }
    return this.eligibleDependents.findIndex(x => x.ssn === authorizedSignerSsn) >= 0;
  }

  isExistingInactiveDependent (authorizedSignerSsn: string) {
    return this.inactiveDependents.findIndex(x => x.ssn === authorizedSignerSsn) >= 0;
  }

  get hasAuthorizedDependentSelectionError () {
    return !isNullEmptyOrUndefined(this.authorizedDependentEligibilityCheckError);
  }

  get propsToDisableWhenAuthorizingDependent () {
    if (!this.isDependentSelected) {
      return [];
    }
    return ["firstName", "middleInitial", "lastName", "dateOfBirth", "ssn"];
  }

  get isDependentSelected () {
    return this.selectedDependentId > 0;
  }

  get isLoading () {
    return this.authorizedSignerStore.isDebitCardEligibilityLoading || this.familyStore.isFamilyStateLoaded === false;
  }

  get isDebitCardEligibilityLoadFailed () {
    return this.authorizedSignerStore.isDebitCardEligibilityLoadFailed;
  }

  get showDebitCardOrderOption () {
    return this.authorizedSignerStore.isEligibleForDebitCard;
  }

  get disableSubmit () {
    return this.errorLoadingRequiredData || this.hasAuthorizedDependentSelectionError;
  }

  get errorLoadingRequiredData () {
    return this.isDebitCardEligibilityLoadFailed;
  }

  get hasEligibleDependents () {
    return this.eligibleDependents && this.eligibleDependents.length > 0;
  }

  get dependentsSelectOptions () {
    return this.eligibleDependents && this.eligibleDependents
      .map(d => ({ value: d.id, text: `${d.firstName} ${d.lastName}` }));
  }

  get eligibleDependents () {
    return this.dependents && this.dependents
      .filter(x =>
        this.isActiveDependent(x) &&
        this.over18(x) &&
        this.notAuthorizedYet(x)
      );
  }

  get inactiveDependents () {
    return this.dependents && this.dependents.filter(d => d.status === FamilyMemberStatus.Inactive);
  }

  get dependents (): FamilyMember[] {
    const supportedValues = [FamilyMemberRelationship.Spouse, FamilyMemberRelationship.Dependent];
    return this.familyStore.isFamilyStateLoaded && this.familyStore
      .familyMembers
      .filter(x =>
        supportedValues.includes(x.relationship)
      );
  }

  get alreadyAuthorizedDependents () {
    const authorizedSigners = Object.keys(this.authorizedSignerStore.authorizedSigners)
      .map(key => this.authorizedSignerStore.authorizedSigners[key]);

    const x = authorizedSigners
      .filter(a => !isNullEmptyOrUndefined(a.userFamilyMemberExternalId))
      .map(a => a.userFamilyMemberExternalId);

    return x;
  }

}
